export default __webpack_public_path__ + "static/media/big-swap-explorer.1cda1b03.svg";